<template>
  <div class="plus" @click="click" :class="{ disabled: disabled }">
    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         x="0px" y="0px"
         viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
              <path d="M256,0C114.844,0,0,114.844,0,256s114.844,256,256,256s256-114.844,256-256S397.156,0,256,0z M405.333,266.667
                c0,5.896-4.771,10.667-10.667,10.667H277.333v117.333c0,5.896-4.771,10.667-10.667,10.667h-21.333
                c-5.896,0-10.667-4.771-10.667-10.667V277.333H117.333c-5.896,0-10.667-4.771-10.667-10.667v-21.333
                c0-5.896,4.771-10.667,10.667-10.667h117.333V117.333c0-5.896,4.771-10.667,10.667-10.667h21.333
                c5.896,0,10.667,4.771,10.667,10.667v117.333h117.333c5.896,0,10.667,4.771,10.667,10.667V266.667z"/>
          </svg>
  </div>
</template>

<script>
export default {
  name: "plus-svg",
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    click (e) {
      this.$emit('click', e);
    }
  }
}
</script>

<style scoped>
svg {
  position: relative!important;
  margin: 0!important;
  padding: 0!important;
}
.disabled {
  opacity: .5;
}
div {
  height: 20px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/svg/plus-svg.vue